// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CO5yhzLrr2WfP0ONfQLa {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6); 
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999; 
    padding: 20px;
  }

  .lWrpvxPcL3kV2rGYiasY {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6); 
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999; 
    padding: 20px;
  }
  
  .AJ08gXPYP9_Xqr_YJ1VG {
    background: white;
    padding: 20px;
    border-radius: 10px;
    min-width: 300px;
    max-width: 90%;
    box-shadow: 0 0 10px rgba(0,0,0,0.3);
    position: relative;
  }

  .GK4yRpFN9ON1ee4FiUhD {
    font-size: 4rem; 
    color: var(--main-color-first) !important;
}`, "",{"version":3,"sources":["webpack://./src/component/modalForm/FullScreenModal.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,yCAAyC;AAC7C","sourcesContent":[".modalover {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background-color: rgba(0, 0, 0, 0.6); \r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 99999; \r\n    padding: 20px;\r\n  }\r\n\r\n  .modaloverContainer {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.6); \r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 99999; \r\n    padding: 20px;\r\n  }\r\n  \r\n  .modalPopup {\r\n    background: white;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    min-width: 300px;\r\n    max-width: 90%;\r\n    box-shadow: 0 0 10px rgba(0,0,0,0.3);\r\n    position: relative;\r\n  }\r\n\r\n  .loadingIcon {\r\n    font-size: 4rem; \r\n    color: var(--main-color-first) !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalover": `CO5yhzLrr2WfP0ONfQLa`,
	"modaloverContainer": `lWrpvxPcL3kV2rGYiasY`,
	"modalPopup": `AJ08gXPYP9_Xqr_YJ1VG`,
	"loadingIcon": `GK4yRpFN9ON1ee4FiUhD`
};
export default ___CSS_LOADER_EXPORT___;
